import React from "react";


function Footer() {
  return (
    <footer className="footer">
      <p>
        Powered by <span>All Rights Reserved.</span>
      </p>
    </footer>
  );
}

export default Footer;
